import { z } from 'zod';

// QuoteLineItem Schema
export const QuoteLineItemSchema = z.object({
  jrpid: z.number().optional(),
  jrptrackingid: z.string().nullable().optional(),
  jrptype: z.string().min(1, "Type is required"),
  jrplabel: z.string().nullable(),
  jrpdetail: z.string().nullable(),
  jrpunits: z.number().nullable(),
  jrpunittype: z.string().nullable(),
  jrpunitcost: z.number().nullable(),
  jrpunitmarkup: z.number().nullable(),
  jrpunittax: z.number().nullable(),
  jrpexcaddmarkup: z.number().nullable(),
  jrpcost: z.number().nullable(),
  jrppub: z.string().nullable(),
  jrppubcost: z.string().nullable(),
  jrpdisp: z.string().nullable(),
  jrpusequotefile: z.number().nullable(),
  jrpuseclaimfile: z.number().nullable(),
  jrpusewofile: z.number().nullable(),
  jrpdate: z.string().nullable(),
  jrpaccept: z.string().nullable(),
  jrpinitials: z.string().nullable(),
  jrpreason: z.string().nullable(),
  jrpreasonnotes: z.string().nullable(),
  jrpsuppid: z.number().nullable(),
  mid: z.number().nullable().optional(),
  miid: z.number().nullable().optional(),
  mpid: z.number().nullable().optional(),
  lcid: z.string().nullable().optional(),
  ltid: z.string().nullable().optional(),
  mstyle: z.string().nullable().optional(),
  jrporder: z.number().nullable(),
  jrpsectionid: z.number().nullable().optional(),
  jrpfilename_s3: z.string().nullable().optional(),
  jrpfilename: z.string().nullable().optional(),
  jrpmfid: z.number().nullable().optional(),
  jrpparenttexttrackingid: z.string().nullable().optional(),
});

// Quote Schema
export const QuoteSchema = z.object({
  jrid: z.number().optional(),
  jrjid: z.number().nullable(),
  jrtype: z.string().nullable(),
  jruid: z.number().nullable(),
  jrdate: z.string().nullable(),
  jrexpire: z.string().nullable(),
  jrneglect: z.string().nullable(),
  jrinsclause: z.string().nullable(),
  jrwarr: z.number().nullable(),
  jrwarr2: z.number().nullable(),
  jrnote: z.string().nullable(),
  jrterms: z.string().nullable(),
  jrtaxrate: z.number().optional().nullable().default(0),
  jrtaxamt: z.number().optional().nullable().default(0),
  jrtotalcost: z.number().optional().nullable().default(0),
  jrdepreq: z.number().optional().nullable().default(0),
  jronote: z.string().nullable(),
  jroedts: z.string().nullable(),
  jrqty: z.string().nullable(),
  lineItems: z.array(QuoteLineItemSchema),
});

// API schemas for quote sections and template sections
export const QuoteSectionApiSchema = z.object({
  jrsid: z.number().optional(),
  jrstrackingid: z.string().nullable().optional(),
  jrswotype: z.string().nullable(),
  jrsjrid: z.number(),
  jrscruid: z.number().nullable(),
  jrsname: z.string(),
  jrsorder: z.number()
});

export type QuoteSectionApi = z.infer<typeof QuoteSectionApiSchema>;

export const QuoteSectionsApiSchema = z.array(QuoteSectionApiSchema);

// Create schemas (omit auto-generated fields)
export const CreateQuoteLineItemSchema = QuoteLineItemSchema.omit({ jrpid: true });
export const CreateQuoteSchema = QuoteSchema.omit({ jrid: true });

// Update schemas (make all fields optional except ID)
export const UpdateQuoteLineItemSchema = QuoteLineItemSchema.partial().required({ jrpid: true });
export const UpdateQuoteSchema = QuoteSchema.partial().required({ jrid: true });

// Type definitions
export type QuoteLineItem = z.infer<typeof QuoteLineItemSchema>;
export type Quote = z.infer<typeof QuoteSchema>;
export type CreateQuoteLineItem = z.infer<typeof CreateQuoteLineItemSchema>;
export type CreateQuote = z.infer<typeof CreateQuoteSchema>;
export type UpdateQuoteLineItem = z.infer<typeof UpdateQuoteLineItemSchema>;
export type UpdateQuote = z.infer<typeof UpdateQuoteSchema>;